<template>
  <v-form ref="accessJustificationForm" v-model="valid">
    <h3 class="mb-3">
      Please explain why you would like access to the data.
    </h3>
    <v-textarea
      v-model="text"
      hint="Max 200 words"
      rows="15"
      counter
      :counter-value="countWords"
      :rules="textAreaRules"
      @keyup="countWords"
    ></v-textarea>
    <v-btn class="mt-3" color="accent" :disabled="!valid" @click="submitForm"
      >Submit</v-btn
    >
  </v-form>
</template>

<script>
export default {
  data: () => ({
    valid: false,
    textAreaRules: [
      v => !!v || "The field cannot be empty",
      v =>
        v.trim().split(/\s+/).length <= 200 ||
        "Only up to 200 words are allowed"
    ],
    text: ""
  }),
  methods: {
    countWords() {
      if (this.text.length > 0) {
        return this.text.trim().split(/\s+/).length;
      } else {
        return 0;
      }
    },
    submitForm() {
      if (this.$refs.accessJustificationForm.validate()) {
        this.$store.state.accessJustification = this.text;
        this.$emit("justificationComplete");
      }
    }
  }
};
</script>
